import React, { Component } from 'react';
import { Table, Input, Button, Icon } from 'antd';
const { Column, ColumnGroup } = Table;
import { observer, inject } from 'mobx-react';
import { OTATableData } from '../../const/TableConst';
import styles from '../DeviceGroup/DeviceSearchForm.less';

@inject('otaStore')
@observer
class OtaTable extends Component {
  onSelectChange = (selectedRowKeys, selectedRows) => {
    this.props.otaStore.selectedTableArr = [...selectedRows];
    this.props.otaStore.selectedRowKeys = selectedRowKeys;
  };
  addSelectRow = item => {
    this.props.otaStore.selectedTableArr.push(item);
    this.props.otaStore.selectedRowKeys.push(item.key);
  };
  handelRowSelect = (record, index, event) => {
    if (!![...this.props.otaStore.selectedRowKeys].length) {
      let selectItem = [...this.props.otaStore.selectedTableArr].findIndex(
        a => a.key === record.key
      );
      if (selectItem > -1) {
        this.props.otaStore.selectedTableArr.splice(selectItem, 1);
        this.props.otaStore.selectedRowKeys.remove(record.key);
      } else {
        this.addSelectRow(record);
      }
    } else {
      this.addSelectRow(record);
    }
  };
  render() {
    const { selectedRowKeys, page_num, changePage } = this.props.otaStore;
    const rowSelection = {
      selectedRowKeys: [...selectedRowKeys],
      onChange: this.onSelectChange
    };
    const { pagesize, changepagesize } = this.props.otaStore;
    let data = [...this.props.otaStore.tableArr].map(item => {
      item.key = item['device_id'];
      return { ...item };
    });
    return (
      <div>
        {
          <Table
            pagination={{
              showTotal: total => (
                <div className={styles.pageSizeContainer}>
                  <span>每页显示条数</span>
                  <Input
                    className={styles.numInput}
                    // defaultValue={10}
                    type="text"
                    value={pagesize}
                    onChange={e => changepagesize(e)}
                  />
                </div>
              ),
              pageSize: pagesize,
              current: page_num,
              onChange: changePage
            }}
            rowSelection={rowSelection}
            columns={OTATableData}
            dataSource={[...data]}
            onRowClick={this.handelRowSelect}
          />
        }
      </div>
    );
  }
}

export default OtaTable;



// WEBPACK FOOTER //
// ./src/components/OTA/OTATable.js